<h1 class="h2 mb-4">Dashboard</h1>
<!-- Basic info-->
<section class="card border-0 py-1 p-md-2 p-xl-3 p-xxl-4 mb-4">
  <div class="card-body">
    <div class="d-flex align-items-center mt-sm-n1 pb-4 mb-0 mb-lg-1 mb-xl-3"><i
        class="ai-user text-primary lead pe-1 me-2"></i>
      <h2 class="h4 mb-0">Profil</h2>
      <a [routerLink]="['/user/profil']" class="btn btn-sm btn-secondary ms-auto"><i
          class="ai-edit ms-n1 me-2"></i>Modifica</a>
    </div>
    <div class="d-md-flex align-items-center">
      <div class="d-sm-flex align-items-center">
        <div class="rounded-circle bg-size-cover bg-position-center flex-shrink-0"
          style="width: 80px; height: 80px; background-image: url({{userImageUrl}});"></div>
        <div class="pt-3 pt-sm-0 ps-sm-3">
          <h3 class="h5 mb-2">{{user?.name}}<i *ngIf="profileCompleteness === 100"
              class="ai-circle-check-filled fs-base text-success ms-2"></i>
          </h3>
          <div class="text-muted fw-medium d-flex flex-wrap flex-sm-nowrap align-iteems-center">
            <div class="d-flex align-items-center me-3"><i class="ai-mail me-1"></i>{{user?.email}}</div>
          </div>
        </div>
      </div>
      <div class="w-100 pt-3 pt-md-0 ms-md-auto" style="max-width: 212px;">
        <div class="d-flex justify-content-between fs-sm pb-1 mb-2">Completarea profilului<strong
            class="ms-2">{{profileCompleteness}}%</strong></div>
        <div class="progress" style="height: 5px;">
          <div class="progress-bar" role="progressbar" [style.width.%]="profileCompleteness" aria-valuenow="62"
            aria-valuemin="0" aria-valuemax="100"></div>
        </div>
      </div>
    </div>
    <div class="row py-4">
      <div class="col-md-6 mb-4 mb-md-0">
        <table class="table mb-0">
          <tbody>
            <tr>
              <td class="border-0 text-muted py-1 px-0">Telefon</td>
              <td class="border-0 text-dark fw-medium py-1 ps-3">{{user?.phone || 'n/a'}}</td>
            </tr>
            <tr>
              <td class="border-0 text-muted py-1 px-0">Locatie</td>
              <td class="border-0 text-dark fw-medium py-1 ps-3">{{getCity(user?.cityId)?.nameFormatted || 'n/a'}}</td>
            </tr>
            <tr>
              <td class="border-0 text-muted py-1 px-0">Data nasterii</td>
              <td class="border-0 text-dark fw-medium py-1 ps-3">{{(user?.birthDate | date:
                'dd/MM/yyyy') || 'n/a'}}</td>
            </tr>
            <tr>
              <td class="border-0 text-muted py-1 px-0">Gen</td>
              <td class="border-0 text-dark fw-medium py-1 ps-3">{{user?.gender === 1 ? 'Masculin' :
                user?.gender === 2 ? 'Feminin' : 'n/a'}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-6 d-md-flex justify-content-end">
        <div class="h-100 bg-secondary rounded-3 p-4">
          <h2 class="h6 pb-2 mb-1">Balanta ta</h2>
          <div class="h2 text-primary mb-2">{{user?.walletAmount | number: '1.2-2'}} lei</div>
          <p *ngIf="user?.walletAmountUpdatedDate" class="fs-sm text-muted mb-0">Ultima actualizare
            {{user?.walletAmountUpdatedDate | date:
            'dd/MM/yyyy'}}</p>
        </div>
      </div>
    </div>
    <div *ngIf="profileCompleteness < 100" class="alert alert-info d-flex mt-2 mt-sm-3 mb-0" role="alert"><i
        class="ai-circle-info fs-xl"></i>
      <div class="ps-2">Completeaza profilul 100% pentru a primi oferte si notificari personalizate. <a
          [routerLink]="['/user/profil']" class="alert-link ms-1">Modifica profilul!</a></div>
    </div>
  </div>
</section>

<!-- Main actions -->
<section class="row row-cols-1 row-cols-sm-3 mb-4">

  <div class="col mb-4 mb-sm-0">
    <a (click)="onCoupon()" class="card card-hover-primary border-0 h-100 text-decoration-none" role="button">
      <div class="card-body pb-0">
        <i class="ai-card h1 fw-normal d-block mb-4 text-warning"></i>
        <h3 class="h4 card-title mt-0">Ai primit un Card Cadou GiftShare?</h3>
        <p class="card-text">Utilizeaza codul pentru a adauga fondurile in contul tau GiftShare.</p>
      </div>
      <div class="card-footer border-0 py-3 my-3 mb-sm-4">
        <div class="btn btn-lg btn-icon btn-outline-primary rounded-circle pe-none"><i class="ai-arrow-right"></i></div>
      </div>
    </a>
  </div>

  <div class="col mb-4 mb-sm-0">
    <a [routerLink]="['/carduri-cadou']" class="card card-hover-primary border-0 h-100 text-decoration-none">
      <div class="card-body pb-0">
        <i class="ai-gift h1 fw-normal d-block mb-4 text-warning"></i>
        <h3 class="h4 card-title mt-0">Vrei sa comanzi un Card Cadou?</h3>
        <p class="card-text">Descopera selectia noastra variata cu peste {{(systemStatistics$ |
          async)?.voucherNonCharityCount}} de magazine partenere.</p>
      </div>
      <div class="card-footer border-0 py-3 my-3 mb-sm-4">
        <div class="btn btn-lg btn-icon btn-outline-primary rounded-circle pe-none"><i class="ai-arrow-right"></i></div>
      </div>
    </a>
  </div>

  <div class="col mb-4 mb-sm-0">
    <a [routerLink]="['/user/creare-eveniment']" class="card card-hover-primary border-0 h-100 text-decoration-none">
      <div class="card-body pb-0">
        <i class="ai-calendar-plus h1 fw-normal d-block mb-4 text-warning"></i>
        <h3 class="h4 card-title mt-0">Vrei sa creezi un eveniment?</h3>
        <p class="card-text">Creeaza o <span class="fw-bold">#ChetaDigitala</span> si invita colegii sau prietenii sa
          contribuie la cadoul de grup.</p>
      </div>
      <div class="card-footer border-0 py-3 my-3 mb-sm-4">
        <div class="btn btn-lg btn-icon btn-outline-primary rounded-circle pe-none"><i class="ai-arrow-right"></i></div>
      </div>
    </a>
  </div>
</section>

<!-- Orders-->
<section class="card border-0 py-1 p-md-2 p-xl-3 p-xxl-4 mb-4">
  <div class="card-body">
    <div class="d-flex align-items-center mt-sm-n1 pb-4 mb-0 mb-lg-1 mb-xl-3"><i
        class="ai-cart text-primary lead pe-1 me-2"></i>
      <h2 class="h4 mb-0">Comenzi <span class="text-muted d-none d-sm-inline-block">({{Math.min(3,
          orderCount)}}/{{orderCount}})</span></h2>
      <div class="d-flex ms-auto">
        <a [routerLink]="['/carduri-cadou']" class="btn btn-primary btn-sm me-2 d-none d-sm-inline-block">
          <i class="ai-gift me-1"></i>Comanda carduri</a>
        <a [routerLink]="['/carduri-cadou']" ngbTooltip="Comanda carduri"
          class="btn btn-primary btn-sm btn-icon me-2 d-sm-none">
          <i class="ai-card"></i></a>
        <a [routerLink]="['/user/comenzi']" class="btn btn-sm btn-secondary ms-auto">
          <span class="d-sm-none">Toate</span>
          <span class="d-none d-sm-inline-block">Toate comenzile</span>
        </a>
      </div>
    </div>
    <ng-container *ngIf="orders">
      <gs-order-list [orders]="orders | slice : 0 : 3" [itemsPerPage]="5"
        [canDisplayPagination]="false"></gs-order-list>
    </ng-container>

    <!-- No items -->
    <div *ngIf="orders?.length === 0" class="card border-0 bg-secondary">
      <div class="card-body">
        <h5 class="card-title">Nicio inregistrare</h5>
        <p class="card-text">Nu exista comenzi de carduri cadou pe contul tau. Doresti sa plasezi o comanda noua?</p>
        <a [routerLink]="['/carduri-cadou']" class="btn btn-primary w-100 w-sm-auto">Comanda un card cadou</a>
      </div>
    </div>

    <!-- Loading template -->
    <div *ngIf="!orders">
      <div *ngFor="let item of [].constructor(3); last as last" [ngClass]="{'border-bottom': last}"
        class="border-top placeholder-glow py-2" aria-hidden="true">
        <span class="placeholder placeholder-lg col-3 me-2"></span>
        <span class="placeholder placeholder-lg col-4 me-2"></span>
        <span class="placeholder placeholder-lg col-3"></span>
        <span class="placeholder col-2 me-2"></span>
        <span class="placeholder col-9"></span>
      </div>
    </div>
  </div>
</section>

<!-- Events-->
<section class="card border-0 py-1 p-md-2 p-xl-3 p-xxl-4">
  <div class="card-body">
    <div class="d-flex align-items-center mt-sm-n1 pb-4 mb-0 mb-lg-1 mb-xl-3"><i
        class="ai-calendar text-primary lead pe-1 me-2"></i>
      <h2 class="h4 mb-0">Evenimente <span class="text-muted d-none d-sm-inline-block">({{Math.min(3,
          eventCount)}}/{{eventCount}})</span></h2>

      <div class="d-flex ms-auto">
        <a [routerLink]="['/user/creare-eveniment']" class="btn btn-primary btn-sm me-2 d-none d-sm-inline-block">
          <i class="ai-calendar-plus me-1"></i>Creeaza eveniment</a>
        <a [routerLink]="['/user/creare-eveniment']" ngbTooltip="Creeaza eveniment"
          class="btn btn-primary btn-sm btn-icon me-2 d-sm-none">
          <i class="ai-calendar-plus"></i></a>
        <a [routerLink]="['/user/evenimente']" class="btn btn-sm btn-secondary ms-auto"><span
            class="d-sm-none">Toate</span>
          <span class="d-none d-sm-inline-block">Toate evenimentele</span></a>
      </div>
    </div>
    <ng-container *ngIf="events">
      <gs-event-list [events]="events | slice : 0 : 3" [itemsPerPage]="9" [canShowAdminButtons]="true"
        [canDisplayPagination]="false"></gs-event-list>
    </ng-container>

    <!-- No items -->
    <div *ngIf="events?.length === 0" class="card border-0 bg-secondary">
      <div class="card-body">
        <h5 class="card-title">Nu ai creat niciun eveniment</h5>
        <p class="card-text">Poti crea un eveniment pentru a oferi un cadou de grup unui prieten/coleg (<span
            class="text-primary">#ChetaDigitala</span>) sau chiar pentru tine 🙂</p>
        <a [routerLink]="['/user/creare-eveniment']" class="btn btn-primary w-100 w-sm-auto">Creeaza eveniment</a>
      </div>
    </div>

    <!-- Loading template -->
    <div *ngIf="!events" class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-4">
      <div *ngFor="let item of [].constructor(3)" class="col">
        <div class="card" aria-hidden="true">
          <div class="position-relative placeholder-glow">
            <div class="card-img-top placeholder ratio ratio-16x9"></div>
            <i class="ai-image position-absolute top-50 start-50 translate-middle fs-1 opacity-50"></i>
          </div>
          <div class="card-body">
            <h5 class="card-title placeholder-glow">
              <span class="placeholder col-6"></span>
            </h5>
            <p class="card-text placeholder-glow">
              <span class="placeholder placeholder-sm col-7 me-2"></span>
              <span class="placeholder placeholder-sm col-4"></span>
              <span class="placeholder placeholder-sm col-4 me-2"></span>
              <span class="placeholder placeholder-sm col-6"></span>
              <span class="placeholder placeholder-sm col-8"></span>
            </p>
            <a href="#" tabindex="-1" class="btn btn-primary disabled placeholder col-6 placeholder-glow"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
